import { api } from './api';

export interface TeacherAvailabilitySlot {
  dayOfWeek: number; // 1..7 (Mo..So)
  time_start: string; // HH:MM:SS
  time_end: string; // HH:MM:SS
}

export interface TeacherDocument {
  id: string;
  name: string;
  url: string;
  contentType?: string | null;
  size?: number | null;
  uploadedAt?: string | null;
  uploadedBy?: number | null;
}

export const personenApi = {
  getStandorte: async (wpUserId: string | number): Promise<number[]> => {
    const url = `/api/personen/${encodeURIComponent(String(wpUserId))}/standorte`;
    return api.get<number[]>(url);
  },
  getTeacherAvailability: async (wpUserId: string | number, standortId: number): Promise<TeacherAvailabilitySlot[]> => {
    const url = `/api/personen/${encodeURIComponent(String(wpUserId))}/availability?standort_id=${encodeURIComponent(String(standortId))}`;
    return api.get<TeacherAvailabilitySlot[]>(url);
  },
  setTeacherAvailability: async (wpUserId: string | number, standortId: number, slots: TeacherAvailabilitySlot[]): Promise<TeacherAvailabilitySlot[]> => {
    const url = `/api/personen/${encodeURIComponent(String(wpUserId))}/availability`;
    return api.put<TeacherAvailabilitySlot[]>(url, { standort_id: standortId, slots });
  },
  getTeacherDocuments: async (wpUserId: string | number): Promise<TeacherDocument[]> => {
    const url = `/api/personen/${encodeURIComponent(String(wpUserId))}/teacher-documents`;
    return api.get<TeacherDocument[]>(url);
  },
  uploadTeacherDocument: async (wpUserId: string | number, file: File): Promise<TeacherDocument> => {
    const formData = new FormData();
    formData.append('file', file);
    const url = `/api/personen/${encodeURIComponent(String(wpUserId))}/teacher-documents`;
    return api.upload<TeacherDocument>(url, formData);
  },
  deleteTeacherDocument: async (wpUserId: string | number, docId: string): Promise<{ ok: boolean }> => {
    const url = `/api/personen/${encodeURIComponent(String(wpUserId))}/teacher-documents/${encodeURIComponent(docId)}`;
    return api.delete<{ ok: boolean }>(url);
  },
};


